/**
 * proposal.ts — Contextos de dados usados por modelos de proposta
 *
 * Registra os namespaces disponíveis para o tipo `proposal`. Os exemplos são
 * valores reais de retorno do sistema, para o usuário montar o modelo sem
 * suposições erradas.
 *
 * RELEASE: v1.0.0 - 2026-09-09 - Versão inicial (Studio, Fase 1)
 */

import { registerContext } from '../contextRegistry';

registerContext({
  namespace: 'tenant',
  label: 'Empresa',
  schema: {
    name: { type: 'string', label: 'Nome da empresa', example: 'W2Sat Rastreamento' },
    document: { type: 'document', label: 'CNPJ', example: '12.345.678/0001-90' },
    email: { type: 'string', label: 'E-mail', example: 'contato@w2sat.com.br' },
    phone: { type: 'phone', label: 'Telefone', example: '(31) 99999-9999' },
    logo_url: { type: 'string', label: 'Logotipo', example: 'https://.../logo.png' },
  },
});

registerContext({
  namespace: 'proposal',
  label: 'Proposta',
  schema: {
    number: { type: 'string', label: 'Número da proposta', example: 'PROP-2026-0042' },
    title: { type: 'string', label: 'Título', example: 'Proposta de rastreamento veicular' },
    description: { type: 'string', label: 'Descrição' },
    status: { type: 'string', label: 'Situação (código)', example: 'sent' },
    currency: { type: 'string', label: 'Moeda', example: 'BRL' },
    subtotal: { type: 'money', label: 'Subtotal', example: '1200.00' },
    discount_total: { type: 'money', label: 'Desconto total', example: '100.00' },
    total: { type: 'money', label: 'Total', example: '1100.00' },
    mrr_total: { type: 'money', label: 'Recorrência mensal', example: '199.90' },
    valid_from: { type: 'date', label: 'Válida a partir de', example: '2026-09-01' },
    expires_at: { type: 'date', label: 'Validade', example: '2026-09-30' },
    conditions_html: { type: 'string', label: 'Condições comerciais' },
    items: {
      type: 'collection',
      label: 'Itens da proposta',
      itemSchema: {
        name: { type: 'string', label: 'Item', example: 'Rastreador GPS' },
        description: { type: 'string', label: 'Descrição' },
        quantity: { type: 'number', label: 'Quantidade', example: '2' },
        unit_price: { type: 'money', label: 'Valor unitário', example: '450.00' },
        discount: { type: 'money', label: 'Desconto', example: '0.00' },
        total: { type: 'money', label: 'Total do item', example: '900.00' },
      },
    },
  },
});

registerContext({
  namespace: 'customer',
  label: 'Cliente',
  schema: {
    name: { type: 'string', label: 'Nome', example: 'Transportes Silva Ltda' },
    document: { type: 'document', label: 'CPF/CNPJ', example: '98.765.432/0001-10' },
    person_type: { type: 'string', label: 'Tipo (código)', example: 'pj' },
    email: { type: 'string', label: 'E-mail', example: 'financeiro@silva.com.br' },
    phone: { type: 'phone', label: 'Telefone', example: '(31) 98888-7777' },
  },
});

registerContext({
  namespace: 'contact',
  label: 'Contato',
  schema: {
    name: { type: 'string', label: 'Nome', example: 'Maria Souza' },
    email: { type: 'string', label: 'E-mail', example: 'maria@silva.com.br' },
    phone: { type: 'phone', label: 'Telefone', example: '(31) 97777-6666' },
  },
});

registerContext({
  namespace: 'deal',
  label: 'Negócio',
  schema: {
    title: { type: 'string', label: 'Título', example: 'Frota 20 veículos' },
    value: { type: 'money', label: 'Valor', example: '1100.00' },
    status: { type: 'string', label: 'Situação (código)', example: 'open' },
  },
});

registerContext({
  namespace: 'seller',
  label: 'Vendedor',
  schema: {
    name: { type: 'string', label: 'Nome', example: 'João Pereira' },
    email: { type: 'string', label: 'E-mail', example: 'joao@w2sat.com.br' },
    phone: { type: 'phone', label: 'Telefone', example: '(31) 96666-5555' },
  },
});
